import { ParagraphEntity, ParagraphValue } from "../pages/Entity/EntityForm";
import { getPostfixForEntity, getPostfix } from "./utils";
import { additionalValuesString } from "./workWithEntities";
import { getEntityPatterns } from "./emptyEntities";
import { getObjectSelectedValue } from "./workWithObjectEntity";

export function getParagraphSelectedValue(paragraph: any): ParagraphValue | null {
    if (!paragraph || !paragraph.values) return null;
    return paragraph.values.find((v: ParagraphValue) => v.value === paragraph.value) || null;
}

export function getCurrentParagraphText(paragraph: any): string {
    if (!paragraph || !paragraph.values) return "";
    const selectedValue = getParagraphSelectedValue(paragraph);
    return selectedValue?.text || "";
}

export function getInnerEntityByKeyword(paragraph: any, keyword: string): ParagraphEntity | null {
    if (!paragraph || !paragraph.values) return null;
    const selectedValue = getParagraphSelectedValue(paragraph);
    if (!selectedValue) return null;
    return selectedValue.entities.find((e: ParagraphEntity) => e.keyword === keyword) || null;
}

export function getAllEntitiesFromTemplate(template: any): any[] {
    const result: any[] = [];
    
    // Добавляем обычные поля
    result.push(...template.entities);
    
    // Добавляем внутренние поля абзацев
    for (const entity of template.entities) {
        if (entity.type === "Абзац" && entity.values) {
            const selectedValue = getParagraphSelectedValue(entity);
            if (selectedValue) {
                // Добавляем внутренние поля с составным ключом
                result.push(...selectedValue.entities.map((innerEntity: ParagraphEntity) => ({
                    ...innerEntity,
                    keyword: `${entity.keyword}.${innerEntity.keyword}`
                })));
            }
        }
    }
    
    // Добавляем внутренние поля объектов
    for (const entity of template.entities) {
        if (entity.type === "Объект" && entity.values) {
            const selectedValue = getObjectSelectedValue(entity);
            if (selectedValue) {
                // Добавляем внутренние поля с составным ключом
                result.push(...selectedValue.entities.map((innerEntity: any) => ({
                    ...innerEntity,
                    keyword: `${entity.keyword}.${innerEntity.keyword}`
                })));
            }
        }
    }
    
    return result;
}

export function getParagraphFullText(entity: any): string {
    if (!entity || entity.type !== "Абзац" || !entity.values) {
        return "";
    }

    const selectedValue = getParagraphSelectedValue(entity);
    if (!selectedValue) return "";
    
    let text = selectedValue.text;
    for (const innerEntity of selectedValue.entities) {
        const fullKeyword = `${entity.keyword.trim()}.${innerEntity.keyword.trim()}`;
        const {rawPattern} = getEntityPatterns(fullKeyword);
        let innerValue = innerEntity.value;
        
        if (innerEntity.needNumberToWords) {
            innerValue += getPostfix(innerValue, true, innerEntity.currency ?? "RUB");
        }
        
        text = text.replace(rawPattern, innerValue);
    }
    return text;
}
